import React from 'react'

function Hero() {
    return (
        <div className="bg-light hero py-5">
            Page not found
        </div>
    )
}

export default Hero;